import React from 'react';
import { Hstack } from '@atoms/layout/Hstack';
import { DhlCard, DhlHeadline, DhlText } from '@dhl-official/react-library';
import { appInsights } from '@/App';


export const ErrorFallbackPage = () => {
  const sessionId = appInsights?.context?.getSessionId() ?? '';
  const traceId = appInsights?.context?.telemetryTrace?.traceID ?? '';

  const errorLink = React.useMemo(() => {
    const newLine = '%0D%0A';
    let link = `mailto:mm_team@dhl.com?subject=M³ WebApp Error`;
    link += `&body=Dear M³ Team,`;
    link += `${newLine}Please try to describe the steps you took before this error appeared and the action you were about to take`;
    link += `${newLine}Details here:`;
    link += `${newLine}`;
    link += `${newLine}-----------------------`;
    link += `${newLine}TraceId: ${traceId}`;
    link += `${newLine}SessionId: ${sessionId}`;
    link += `${newLine}Time: ${new Date().toLocaleString()}`;
    return link;
  }, [traceId, sessionId]);

  return (
    <Hstack>
      <DhlCard>
        <DhlHeadline designLevel={'5'}>
          Something went wrong 😢
        </DhlHeadline>
        <DhlText>
          Please contact the M³ Team 🧑‍💻 at <a href={errorLink}>mm_team@dhl.com</a>
        </DhlText>
      </DhlCard>
    </Hstack>
  );
}